import { render, staticRenderFns } from "./setGoods.vue?vue&type=template&id=409a998a&"
import script from "./setGoods.vue?vue&type=script&lang=js&"
export * from "./setGoods.vue?vue&type=script&lang=js&"
import style0 from "./setGoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports